import React, { useMemo } from "react";

import { useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router";

import RouteDrawer, { RouteDrawerProps } from "components/RouteDrawer";
import makeStyles from "hooks/makeStyles";

import OrderTypeModal from "./OrderTypeModal";

const useStyles = makeStyles(theme => ({
	root: {},
	paper: {
		borderRadius: `0 0 ${theme.spacing(2)}px ${theme.spacing(2)}px`,
		backgroundColor: "rgba(33,33,33,0.7)",
		WebkitBackdropFilter: "blur(5px)",
		backdropFilter: "blur(5px)",
		color: "#fff",
		padding: theme.spacing(2),
		display: "flex",
		[theme.breakpoints.up(480)]: {
			height: "100vh",
			borderRadius: "0",
			width: "80%",
			maxWidth: "442px",
			left: "auto",
			backgroundColor: theme.palette.background.paper,
			padding: 0,
			color: theme.palette.text.primary
		},
		[theme.breakpoints.up(769)]: {
			width: "50%"
		}
	},
	backdrop: {
		backgroundColor: "rgba(0,0,0,0.1)",
		[theme.breakpoints.up(480)]: {
			backgroundColor: "transparent",
			WebkitBackdropFilter: "blur(1.8px)",
			backdropFilter: "blur(1.8px)"
		}
	}
}));

type Props = Omit<RouteDrawerProps, "swipeable" | "matchRoute">;

const OrderTypeDrawer = ({ className, ...otherProps }: Props) => {
	const { hash } = useLocation();
	const navigate = useNavigate();
	const classes = useStyles();
	const mobile = useMediaQuery("(max-width:480px)");

	const close = useMemo(
		() => () => {
			if (hash === "#order-type?") {
				navigate("#");
			}
		},
		[hash, navigate]
	);

	const props: RouteDrawerProps = useMemo(
		() =>
			Object.assign(
				{
					className: clsx(classes.root, className),
					classes: { paper: classes.paper },
					BackdropProps: {
						className: classes.backdrop
					},
					anchor: mobile ? "top" : "right",
					disableSwipeToOpen: true,
					swipeable: true,
					matchRoute: ({ location: { hash } }) => hash === "#order-type?",
					onClose: close,
					onOpen: () => {}
				},
				otherProps
			),
		[className, classes.backdrop, classes.paper, classes.root, close, mobile, otherProps]
	);

	return (
		<RouteDrawer {...props}>
			<OrderTypeModal onClose={close} />
		</RouteDrawer>
	);
};

export default OrderTypeDrawer;
